import EdUpload from './src/index.vue'

/* istanbul ignore next */
EdUpload.install = function (Vue) {
  Vue.component(EdUpload.name, EdUpload)
}

export default EdUpload
